<template>
  <div class="mb-8" v-if="newsEntry">
    <div class="stack">
      <div class="p-4 pb-2 w-full max-w-md sm:px-0 mx-auto">
        <p class="-ml-1 text-xs mt-2 mb-6 font-medium uppercase tracking-wider">
          <span
            v-if="newsCategory"
            class="px-3 py-1 border rounded-lg"
            :style="{ borderColor: newsCategory.color }"
            >{{ newsCategory.title }}</span
          >
          <span
            v-if="activityCategory"
            class="ml-2 px-3 py-1 border rounded-lg"
            :style="{ borderColor: activityCategory.color }"
            >{{ activityCategory.title }}</span
          >
        </p>
        <h1 class="mb-0 text-2xl lg:text-3xl">{{ newsEntry.title }}</h1>
        <p class="italic">
          {{ momentFormat(newsEntry.published_at, "DD.MM.YYYY") }}
        </p>
        <div class="my-1" v-if="newsEntry">
          <share-button
            :title="newsEntry.title"
            :url="`${basePath}/single-news/${newsEntry.slug || newsEntry.id}`"
          />
        </div>
        <div class="my-4 text-xl markdown">
          <vue-markdown
            :source="newsEntry.summary"
            :anchorAttributes="{
              target: '_blank',
              rel: 'nofollow',
            }"
          />
        </div>
      </div>
    </div>
    <div class="stack-lg" v-if="newsEntryItems.length > 0">
      <news-entry-item
        v-for="item in newsEntryItems"
        :key="item.id"
        :item="item"
      />
      <div class="max-w-lg mx-auto p-8 text-center stack-lg border-t border-gray-400">
        <div class="max-w-sm mx-auto stack">
          <div class="text-3xl"><icon name="Info" /></div>
        <div class="text-xl font-medium">{{ $t('news.please_share_title') }}</div>
        <div>{{ $t('news.please_share_text') }}</div>
        </div>
        <div v-if="newsEntry">
          <share-button :title="newsEntry.title"
            :url="`${basePath}/single-news/${newsEntry.slug || newsEntry.id}`" />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
const NewsEntryItem = require("@/modules/home/components/NewsEntryItem.vue")
  .default;
const ShareButton = require("@/modules/core/components/ShareButton.vue")
  .default;
import VueMarkdown from "vue-markdown";

import moment from "moment";
import DateMixin from "@/mixins/DateMixin";

export default {
  name: "NewsDetailSite",
  mixins: [DateMixin],
  data() {
    return {
      newsEntry: null,
      newsEntryItems: [],
      newsCategory: null,
      activityCategory: null,
      basePath: "",
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  components: {
    NewsEntryItem,
    VueMarkdown,
    ShareButton,
  },
  methods: {},
  computed: {},
  async created() {
    this.basePath = window.location.origin;

    let uuidRegex = /[\w]{8}-[\w]{4}-[\w]{4}-[\w]{4}-[\w]{12}/;
    if (uuidRegex.test(this.id)) {
      this.newsEntry = await this.$store.getters["newsentry/api"].Show(this.id);
    } else {
      this.newsEntry = await this.$store.getters[
        "newsentry/api"
      ].Custom.GetEntryBySlug(this.id);
    }

    this.newsCategory = await this.$store.getters["newscategory/api"].Show(
      this.newsEntry.news_category_id
    );
    this.activityCategory = await this.$store.getters[
      "activitycategory/api"
    ].Show(this.newsEntry.activity_category_id);
    this.newsEntryItems = await this.$store.getters[
      "newsentryitem/api"
    ].Custom.ShowItemsOfEntry(this.newsEntry.id);

    this.$store.dispatch("header/update", {
      backbutton: true,
      clear: true,
      elements: [
        {
          value: "News",
          css: "tracking-wider font-medium",
        },
      ],
    });
  },
};
</script>
